import  { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { selectRegion } from "../features/counter/RegionSlice";
import Sales from "../Data/Sales";


import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { Box, Typography } from "@mui/material";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const TotalCallsChart = () => {
  const region = useSelector(selectRegion);
  const [jsonData, setJsonData] = useState([]);
 

  useEffect(() => {
    const filteredData =
      region === "All Region"
        ? Sales.Data
        : Sales.Data.filter((item) => item.Region === region);
    setJsonData(filteredData);
  }, [region]);

  useEffect(() => {
    setJsonData(Sales.Data);
  }, []);

  const data = {
    labels: jsonData.map((item) => item.Salesman),
    datasets: [
      {
        label: "Calls",
        data: jsonData.map((item) => item.Calls),
        backgroundColor: "purple",
      },
      {
        label: "Total Feedback",
        data: jsonData.map((item) => item.Total),
        backgroundColor: "yellow",
      },
    ],
  };

  const options = {
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">Total Calls - {region}</Typography>
        <Box display="flex" gap={2}>
          <Box display="flex" alignItems="center">
            <Box sx={{ width: 16, height: 16, backgroundColor: 'purple', mr: 1 }} />
            <Typography variant="body2">Calls</Typography>
          </Box>
          <Box display="flex" alignItems="center">
            <Box sx={{ width: 16, height: 16, backgroundColor: 'yellow', mr: 1 }} />
            <Typography variant="body2">Total Feedback</Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Bar data={data} options={options} />
      </Box>
    </Box>
  );
};

export default TotalCallsChart;
